import Button from '@mui/material/Button';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Image from 'components/Image';
import React from 'react';
import HiveSignerLogo from '../../../images/hive.svg';

export default function HiveBtn({ text }) {
  const hiveBtnTheme = createTheme({
    palette: {
      primary: {
        main: '#E31337',
      },
    },
    typography: {
      button: {
        width: '300px',
        textTransform: 'none',
      },
    },
  });

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={hiveBtnTheme}>
        <Button
          color="primary"
          variant="contained"
          size="large"
          className="p-2"
        >
          <Image
            className="pl-3"
            src={HiveSignerLogo}
            alt="Sign up for Hive"
            height={41}
            width={70}
          />{' '}
          <Typography className="pl-3 pr-2" variant="h6">
            {text}
          </Typography>
        </Button>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
